module.exports = __webpack_public_path__ + "img/introduction.4b19099e.png";